import './App.css';
import { Navigate, Routes, Route } from "react-router-dom"
import HomeMobile from './pages/mobile/Home';
import MainMobile from './pages/mobile/Main';
import HomeMobilePersonalia from './pages/mobile/Personalia/Absensi/Home';
import NotFound404 from './pages/404';
import LoginPage2 from './pages/Login2';
import HomeMobileSegel from './pages/mobile/Hublang/Segel';
import InstallPrompt from './components/InstallPrompt';
import PersonaliaDataAbsensi from './pages/mobile/Personalia/FormAbsensi';

function App() {
  return (
    <>
      {/* Menu navigasi */}
      {/* Routing */}
      <Routes>
        <Route path="/" element={<Navigate to="/mobile" replace />} />
        {/* <Route path="/login" element={<Login />} /> */}
        <Route path="/login" element={<LoginPage2 />} />
        <Route path="/mobile" element={<HomeMobile />}>
          <Route index element={<MainMobile />} />
          <Route path="personalia/*" element={<HomeMobilePersonalia />} />
          <Route path="segel" element={<HomeMobileSegel />} />
          <Route path="form-absensi" element={<PersonaliaDataAbsensi />} />
        </Route>

        <Route path="*" element={ <NotFound404 /> } />
      </Routes>

      <InstallPrompt />
    </>
  );
}

export default App;
